import React from "react";
import TextareaInput from "../inputs/TextareaInput";

const Textarea = ({
	register,
	error,
	placeholder = "Enter text",
	required = false,
	className = "",
	id,
	field,
	rows = 4,
	cols,
}) => {
	return (
		<TextareaInput
			label=""
			placeholder={placeholder}
			required={required}
			error={error}
			hideLabel={true}
			rows={rows}
			cols={cols}
			{...register(id, {
				required: required
					? `${field.title || "This field"} is required`
					: false,
			})}
			name={id}
		/>
	);
};

export default Textarea;
